import { cx } from 'class-variance-authority';

export type HintProps = {
  size?: 'compact' | 'default';
  children: string;
  className?: string;
  hasError?: boolean;
  id?: string;
};

const Hint = ({ children, className, hasError = false, id, size = 'default' }: HintProps) => (
  <div
    id={id}
    className={cx('fp-hint fp-custom-appearance mt-2', className)}
    data-has-error={hasError}
    data-size={size}
  >
    {children}
  </div>
);

export default Hint;
